import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import VueNumerals from 'vue-numerals';
import axios from 'axios';
// @ts-ignore
import numeral from 'numeral';


// Load fonts
loadFonts();

// Create an Axios instance with default settings
const axiosInstance = axios.create({
  // baseURL: 'http://127.0.0.1:8000/api', // Local Dev
  baseURL: 'https://api.gp21shop.biz.id/api', //Staging
  timeout: 10000, // Optional: Set a timeout (in milliseconds)
  headers: {
    'Content-Type': 'application/json',
  },
});

// Create the Vue application
const app = createApp(App);

// Use Axios as a global property
app.config.globalProperties.$axios = axiosInstance;
// app.config.globalProperties.$urlImage = 'https://apistg.jstickshop.com/'
app.config.globalProperties.$urlImage = 'https://api.gp21shop.biz.id/'
// app.config.globalProperties.$urlImage = 'http://127.0.0.1:8000/'

// Use the router and vuetify
app.use(router);
app.use(vuetify);
app.use(numeral)

app.use(VueNumerals, {
  locale: 'en'
});

// Mount the app
app.mount('#app');
